module.exports = __webpack_public_path__ + "static/media/lila-saxlift.593aef9f.jpg";